(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["varela-shipping-strip"] && !Shopify.designMode) return;
  try {
    (function () {
  function rand(a, b) { return Math.floor(Math.random() * (b - a + 1)) + a; }
  document.querySelectorAll('.vb-ship-views').forEach(function (el) {
    if (el.dataset.vbInit) return;
    el.dataset.vbInit = '1';
    var min = parseInt(el.dataset.min, 10) || 30;
    var max = parseInt(el.dataset.max, 10) || 70;
    if (max < min) { var t = min; min = max; max = t; }
    var nEl = el.querySelector('.vb-ship-views__n');
    var labelEl = el.querySelector('.vb-ship-views__label');
    if (labelEl) labelEl.textContent = el.dataset.text || 'personas viendo esto ahora';
    var current = rand(min, max);
    if (nEl) nEl.textContent = current;
    setInterval(function () {
      current += rand(-2, 2);
      if (current < min) current = min + rand(0, 2);
      if (current > max) current = max - rand(0, 2);
      if (nEl) nEl.textContent = current;
    }, 4000);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["varela-urgency"] && !Shopify.designMode) return;
  try {
    (function () {
  function rand(a, b) { return Math.floor(Math.random() * (b - a + 1)) + a; }

  document.querySelectorAll('.vb-urg-views').forEach(function (el) {
    var min = parseInt(el.dataset.min, 10) || 8;
    var max = parseInt(el.dataset.max, 10) || 24;
    if (max < min) { var t = min; min = max; max = t; }

    var nEl = el.querySelector('.vb-urg-views__n');
    var labelEl = el.querySelector('.vb-urg-views__label');
    if (labelEl) labelEl.textContent = el.dataset.text || 'personas viendo esto ahora';

    var current = rand(min, max);
    if (nEl) nEl.textContent = current;

    setInterval(function () {
      current += rand(-2, 2);
      if (current < min) current = min + rand(0, 2);
      if (current > max) current = max - rand(0, 2);
      if (nEl) nEl.textContent = current;
    }, 4000);
  });

  // Stock real por talla (solo se muestra cuando es verdad: 0 < stock <= umbral)
  document.querySelectorAll('.vb-urg--stock').forEach(function (el) {
    var map = {};
    try { map = JSON.parse(el.dataset.vbStock || '{}'); } catch (e) { return; }
    var threshold = parseInt(el.dataset.threshold, 10) || 5;
    var tpl = el.dataset.text || '🔥 ¡Solo quedan {n} en tu talla!';
    var textEl = el.querySelector('.vb-urg-text');
    var root = el.closest('.shopify-section, product-information, [id^="MainProduct"]') || document;

    function currentId() {
      var input = root.querySelector('[name="id"]') || document.querySelector('product-form [name="id"], form[action*="/cart/add"] [name="id"], [name="id"]');
      return input ? String(input.value) : null;
    }

    function render() {
      var id = currentId();
      var qty = id && Object.prototype.hasOwnProperty.call(map, id) ? map[id] : null;
      if (qty !== null && qty > 0 && qty <= threshold) {
        if (textEl) textEl.textContent = tpl.replace('{n}', qty);
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    }

    render();
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'id' || e.target.closest && e.target.closest('product-form, form[action*="/cart/add"], variant-picker, .product-form'))) {
        setTimeout(render, 60);
      }
    }, true);
    var last = currentId();
    setInterval(function () {
      var now = currentId();
      if (now !== last) { last = now; render(); }
    }, 700);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vb-aviso-stock"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(box) {
      if (box.dataset.vbBisListo) return; box.dataset.vbBisListo = '1';
      var variantes; try { variantes = JSON.parse(box.querySelector('[data-vb-bis-variants]').textContent); } catch (e) { return; }
      var form = box.querySelector('[data-vb-bis-form]'), msg = box.querySelector('[data-vb-bis-msg]'), sel = box.querySelector('[data-vb-bis-sel]');
      var raiz = box.closest('product-information, .product-information, main') || document;
      var pulsada = null, colorVisto = null;
      function idSeleccionada() {
        var inp = raiz.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
        if (inp && inp.value) return String(inp.value);
        return new URL(location.href).searchParams.get('variant');
      }
      function colorActual() {
        var b = raiz.querySelector('.vb-cvp-img-btn.vb-active');
        if (b && b.dataset.value) return b.dataset.value;
        var id = idSeleccionada(), v = variantes.find(function (x) { return String(x.id) === String(id); });
        return v ? v.option1 : (variantes[0] && variantes[0].option1);
      }
      function agotadas(color) {
        return variantes.filter(function (v) { return v.option1 === color && !v.available; })
          .sort(function (a, b) { return parseFloat(String(a.option2).replace(',', '.')) - parseFloat(String(b.option2).replace(',', '.')); });
      }
      function refresca() {
        var color = colorActual(), lista = agotadas(color);
        if (color !== colorVisto) { colorVisto = color; msg.textContent = ''; msg.className = 'vb-bis__msg'; }
        box.hidden = !lista.length;
        if (!lista.length) return;
        var antes = sel.value, id = idSeleccionada(), elegida = variantes.find(function (x) { return String(x.id) === String(id); });
        sel.innerHTML = lista.map(function (v) { return '<option value="' + v.id + '">' + v.option2 + '</option>'; }).join('');
        var quiero = pulsada || (elegida && !elegida.available && elegida.option1 === color ? elegida.option2 : null);
        var op = quiero ? lista.find(function (v) { return v.option2 === quiero; }) : null;
        if (op) sel.value = String(op.id); else if (antes && lista.some(function (v) { return String(v.id) === antes; })) sel.value = antes;
      }
      // al pulsar una talla tachada: el aviso, con esa talla puesta
      raiz.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('.vb-cvp-size-btn.vb-oos') : null;
        if (!b) return;
        pulsada = b.dataset.value; refresca(); pulsada = null;
        if (!box.hidden) { box.scrollIntoView({ block: 'center', behavior: 'smooth' }); setTimeout(function () { form.email.focus({ preventScroll: true }); }, 350); }
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault(); var email = form.email.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { msg.className = 'vb-bis__msg err'; msg.textContent = 'Escribe un correo válido.'; form.email.focus(); return; }
        var v = variantes.find(function (x) { return String(x.id) === sel.value; });
        if (!v) return;
        var btn = form.querySelector('button'); btn.disabled = true; msg.className = 'vb-bis__msg'; msg.textContent = 'Un momento…';
        fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(box.dataset.company), {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } },
            relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + v.id } } } } })
        }).then(function (r) {
          if (r.status === 202 || r.ok) { msg.className = 'vb-bis__msg ok'; msg.textContent = 'Listo: te avisamos por correo en cuanto vuelva la ' + v.option2 + ' en ' + String(v.option1).toLowerCase() + '.'; form.email.value = ''; }
          else { throw new Error('status ' + r.status); }
        }).catch(function () { msg.className = 'vb-bis__msg err'; msg.textContent = 'No hemos podido apuntarte. Escríbenos a contacto@varelabarcelona.com y te avisamos nosotros.'; })
          .finally(function () { btn.disabled = false; });
      });
      refresca();
      raiz.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.vb-cvp-img-btn, .vb-cvp-size-btn')) setTimeout(refresca, 80); });
      document.addEventListener('change', function (e) { if (e.target && (e.target.name === 'id' || e.target.closest('variant-picker, .variant-picker, [data-variant-picker]'))) setTimeout(refresca, 60); });
      window.addEventListener('popstate', refresca);
      var last = location.search; setInterval(function () { if (location.search !== last) { last = location.search; refresca(); } }, 500);
    }
    function arranca() { document.querySelectorAll('[data-vb-bis]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca); else arranca();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vb-trust-badges"] && !Shopify.designMode) return;
  try {
    // Fila «¿Primer pedido?» (13/10/2026): solo si existe la ventana propia de la lista VIP y la clienta no se ha apuntado ya
  (function () {
    function pinta() {
      var filas = document.querySelectorAll('[data-vb-tb-vip]'); if (!filas.length) return;
      var suscrita = false; try { suscrita = localStorage.getItem('vb-vip-suscrita') === '1'; } catch (e) {}
      filas.forEach(function (f) {
        if (suscrita || typeof window.vbVipAbrir !== 'function') { f.remove(); return; }
        f.hidden = false;
        if (!f.dataset.vbListo) { f.dataset.vbListo = '1'; f.addEventListener('click', function () { window.vbVipAbrir(); }); }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pinta); else pinta();
    window.addEventListener('load', pinta);
  })();
  } catch(e) { console.error(e); }
})();

})();
